import React from 'react';
import { Link } from 'react-router-dom';
import blueCar from '../assets/images/blue_car.png';
import redCar from '../assets/images/red_car.png';
import smile from '../assets/images/smile.png';
import conduiteSupervisee from '../assets/images/conduite-superviser.png';
import './Formations.css';

const Formations = () => {
  const formations = [
    {
      id: 'permis-b',
      title: 'Permis B',
      description: 'Cours de conduite',
      subtitle: 'dès 17 ans',
      image: blueCar,
      color: 'orange',
      buttonText: '+Infos',
      link: '/formations-permis-b'
    },
    {
      id: 'permis-aac',
      title: 'Permis AAC',
      description: 'Conduite accompagnée',
      subtitle: 'dès 15 ans',
      image: smile,
      color: 'blue',
      buttonText: '+Infos',
      link: '/aac'
    },
    {
      id: 'code-route',
      title: 'Code de la Route',
      description: 'Préparation au code',
      image: redCar,
      color: 'orange',
      buttonText: '+Infos',
      link: '/code'
    },
    {
      id: 'conduite-supervisee',
      title: 'Conduite Supervisée',
      description: 'Pratique supervisée',
      subtitle: 'dès 18 ans',
      image: conduiteSupervisee,
      color: 'blue',
      buttonText: '+Infos',
      link: '/conduite-supervisee'
    }
  ];

  return (
    <div className="formations-page">
      <section className="formations-hero">
        <div className="container">
          <h1 className="formations-title">Nos Formations</h1>
        </div>
      </section>
      <section className="formations-list">
        <div className="container">
          <div className="formations-grid">
            {formations.map((formation) => (
              <div key={formation.id} className={`formation-card ${formation.color}`}>
                <div className="formation-content">
                  <h2 className="formation-card-title">{formation.title}</h2>
                  <p className="formation-card-description">{formation.description}</p>
                  {formation.subtitle && (
                    <p className="formation-card-subtitle">{formation.subtitle}</p>
                  )}
                  <Link to={formation.link} className="formation-button">
                    {formation.buttonText}
                  </Link>
                </div>
                <div className="formation-image">
                  <img src={formation.image} alt={formation.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Formations;
